<template>
  <div class="justify-content-md-center">
    <b-overlay :show="constantValue.isConvertingHeic" rounded="sm">
      <div>
        <b-card no-body v-if="getListFileByType().length > 0" class="mb-3 noborder" body-class="py-0">
          <!-- <b-container > -->
          <div v-for="readItem in getListFileByType()" v-bind:key="readItem.id">
            <b-row class="px-1 no-gutters" align-v="center" style="margin-right: 0px; margin-left: 0px">
              <b-col cols="auto mr-3">
                <b-img width="43" height="43" :src="getPreview(readItem.id)"
                  :class="'preview-' + getFileType(readItem.id)"></b-img>
              </b-col>
              <b-col cols="8" class="text-muted" :id="'Upload_ViewDoc_' + readItem.type" align-self="center">
                <div class="content-nowrap font-kanit-regular-16 text-kanit-color-black">
                  {{ readItem.filename }}
                </div>
                <div class="font-kanit-regular-14 text-kanit-color-grey">
                  {{ getFileSize(readItem.filesize) }}
                </div>
              </b-col>
              <template v-if="!checkDocIsSuccess()">
                <b-col cols="auto ml-auto" class="" @click="remove(readItem.id)" style="cursor: pointer">
                  <div style="color: #087ffd">
                    <b-img :id="'Upload_RemoveDoc_' + readItem.type" :src="constantValue.iconTrash" width="20"
                      height="20"></b-img>
                  </div>
                </b-col>
              </template>
            </b-row>
          </div>

          <!-- </b-container> -->
        </b-card>
        <div class="d-flex justify-content-center">
          <input :id="'fileUpload_' + documentTypeObj.doc_code" @change="onFileChange($event)" type="file" multiple
            hidden :accept="constantValue.acceptFile" />

          <input :id="'fileBrowseImage_' + documentTypeObj.doc_code" @change="onFileChange($event)" type="file" hidden
            multiple accept="image/jpeg,image/png,image/jpg,image/heic" />

          <input :id="'fileBrowseIOS_' + documentTypeObj.doc_code" @change="onFileChange($event)" type="file" hidden
            multiple accept="image/jpeg,image/png,image/jpg,image/heic,application/pdf" />

          <input :id="'fileBrowseFile_' + documentTypeObj.doc_code" @change="onFileChange($event)" type="file" hidden
            accept="application/pdf" />

          <input :id="'fileCamera_' + documentTypeObj.doc_code" @change="onFileChange($event)" type="file" capture
            hidden accept="image/jpeg,image/png,image/jpg,image/heic" />

          <button style="border: none" :id="'upload_chooseFiles_' + documentTypeObj.doc_code" @click="chooseFiles()"
            class="upload-button-revamp" :disabled="checkDocIsSuccess()">
            <b-row align-v="center" style="
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 8px;
              ">
              <b-img left :src="constantValue.iconUploads" width="24" height="24" />
              <span class="font-kanit-bold-16">เลือกเอกสาร</span>
            </b-row>
          </button>
        </div>
        <div>
          <b-row class="text-center pt-3" v-if="
            viewRecommend &&
            documentTypeObj.example_doc !== null &&
            documentTypeObj.example_doc.length > 0
          " @click="showExample">
            <b-col>
              <span class="span-aherf-text font-kanit-regular-14">ดูข้อแนะนำและตัวอย่างเอกสาร</span>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-overlay>

    <b-modal v-if="constantValue.isClosing" id="modal-upload" v-model="constantValue.modalShow" hide-header
      hide-header-close hide-footer centered @hide="closeDialogChooseFile" no-fade
      content-class="modal-attachfile-modal_content" dialog-class="mb-4">
      <div class="px-3 pb-4 justify-content-center">
        <b-row style="float: left">
          <b-col class="w-100" style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              color: #111928;
            ">
            <span class="font-kanit-bold-16" style="color: #000000">เลือกรูปแบบ</span>
            <b-img left :src="constantValue.iconClose" style="width: 12px; height: 12px"
              @click="hideModalUpload"></b-img>
          </b-col>
          <div class="w-100 py-2" />
          <b-col @click="selectedOptionFile(1)" :id="'upload_file_camera_' + documentTypeObj.doc_code">
            <b-img left :src="constantValue.iconCamera" class=""></b-img>
            <span class="px-3 font-kanit-regular-16-400 text-kanit-color-black">ถ่ายรูป</span>
          </b-col>
          <div class="w-100 px-3">
            <hr />
          </div>

          <b-col @click="selectedOptionFile(2)" :id="'upload_file_browseImages_' + documentTypeObj.doc_code">
            <b-img left :src="constantValue.iconBrowseImages"></b-img>
            <span class="px-3 font-kanit-regular-16-400 text-kanit-color-black">อัลบั้มรูป</span>
          </b-col>
          <div class="w-100 px-3">
            <hr />
          </div>
          <b-col @click="selectedOptionFile(3)" :id="'upload_file_browseFiles_' + documentTypeObj.doc_code">
            <b-img left :src="constantValue.iconBrowseFile" height="20" width="20"></b-img>
            <span style="margin-left: 4px"
              class="px-3 font-kanit-regular-16-400 text-kanit-color-black">เลือกไฟล์</span>
          </b-col>
          <div class="w-100 pb-3"></div>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { exampleDoc } from "@/utils/popup/ExampleDoc.js";
import { Warning, WarningPassword } from "@/utils/popup/Warning.js";
import { convertFileCloudToLocal } from "@/utils/Upload.js";
import heic2any from "heic2any";
import pdf from "vue-pdf";
export default {
  props: {
    documentTypeObj: Object,
    viewRecommend: Boolean,
    callback: Function,
    onReceiveNativeCommand: Function,
    uploadType: String,
  },
  data() {
    return {
      attachFile: [],
      userData: {},

      constantValue: {
        acceptFile: process.env.VUE_APP_ACCEPTFILE,
        modalShow: false,
        isConvertingHeic: false,
        iconUploads: require("@/assets/images/revamp-upload-ic.png"),
        iconTrash: require("@/assets/images/iconTrash.png"),
        iconCamera: require("@/assets/images/FileCamera.png"),
        iconBrowseFile: require("@/assets/images/FileDoc.png"),
        iconBrowseImages: require("@/assets/images/FileImage.png"),
        iconClose: require("@/assets/images/ic_upload_close.png"),
        isClosing: false,
        alert: {
          size: {
            title: "ขนาดไฟล์เกินพื้นที่รองรับ",
            detail: "กรุณาตรวจสอบขนาดไฟล์อีกครั้ง",
            close: "ตกลง",
          },
          typefile: {
            title: "เอกสารของคุณใช้รูปแบบไฟล์ที่ไม่รองรับ",
            detail: "เอกสารต้องเป็นไฟล์ JPG, PNG, HEIC หรือ PDF",
            close: "ตกลง",
          },

          filenameDuplicate: {
            title: "ยืนยันบันทึกเอกสารใหม่ทับเอกสารเดิม?",
            detail:
              "พบเอกสารที่มีชื่อซ้ำกัน หากยืนยัน<br />ระบบจะบันทึกเอกสารทับเอกสารเดิม",
            close: "ตกลง",
          },

          sizeAndTypeFile: {
            title: "กรุณาตรวจสอบไฟล์",
            detail:
              "ประเภทของไฟล์ที่รองรับได้แก่ .pdf, .png, .jpg หรือ .heic เท่านั้น โดยขนาดข้อมูลรวมกันต้องมีขนาดไม่เกิน " +
              process.env.VUE_APP_MAXSIZE +
              " MB",
            close: "ตกลง",
          },
          fileEmpty: {
            title: "ไม่สามารถเปิดไฟล์ได้",
            detail: "กรุณาตรวจสอบไฟล์อีกครั้ง",
            close: "ตกลง",
          },
        },
      },
    };
  },
  created() {
    this.constantValue.isClosing = true;
    this.userData = this.$store.getters.getUserData;
  },
  beforeUpdate() {
    this.mapInitProps();
  },
  beforeMount() {
    this.mapInitProps();
  },
  methods: {
    mapInitProps() {
      if (
        this.documentTypeObj.filesReal !== undefined &&
        this.documentTypeObj.filesReal.length > 0
      ) {
        this.attachFile = [...this.documentTypeObj.filesReal];
      } else {
        this.attachFile = [];
      }
    },
    setGlobalDocType() {
      this.$callback.setDocType(this.documentTypeObj.doc_code);
      this.$callback.requestCamera();
    },
    async chooseFiles() {
      // console.log("Click choose file");
      if (this.userData.isAndroid) {
        this.openDialogChooseFile();
      } else {
        await this.onReceiveNativeCommand(this.documentTypeObj.doc_code);
        this.defaultPopupIOS();
      }
    },
    defaultPopupIOS() {
      try {
        document
          .getElementById(`fileCamera_${this.documentTypeObj.doc_code}`)
          .setAttribute("onclick", null);
        document
          .getElementById(`fileCamera_${this.documentTypeObj.doc_code}`)
          .setAttribute(
            "onclick",
            `document.getElementById("fileBrowseIOS_${this.documentTypeObj.doc_code}").click(); return false;`
          );
        this.$callback.requestCamera();
      } catch (error) {
        console.error("defaultPopupIOS");
        document
          .getElementById("fileBrowseIOS_" + this.documentTypeObj.doc_code)
          .click();
      }
    },
    async selectedOptionFile(type) {
      try {
        if (type == 1) {
          try {
            await this.onReceiveNativeCommand(this.documentTypeObj.doc_code);
            this.$callback.requestCamera();
          } catch (error) {
            document
              .getElementById("fileCamera_" + this.documentTypeObj.doc_code)
              .click();
          }
        } else if (type == 2) {
          document
            .getElementById("fileBrowseImage_" + this.documentTypeObj.doc_code)
            .click();
        } else if (type == 3) {
          document
            .getElementById("fileBrowseFile_" + this.documentTypeObj.doc_code)
            .click();
        } else {
          document
            .getElementById("fileUpload_" + this.documentTypeObj.doc_code)
            .click();
        }
      } catch (error) {
        // document.getElementById("fileUpload").click();
      }
    },
    async openDialogChooseFile() {
      this.constantValue.modalShow = true;
      this.constantValue.isClosing = true;
      this.isClosing = false;
      // await new Promise((resolve) => setTimeout(resolve, 1));
      this.$nextTick(() => {
        const modal = document.querySelector(".modal-attachfile-modal_content");
        if (modal) {
          modal.classList.remove("hidden");
          modal.classList.remove("slide-down");
          modal.classList.add("slide-up");
        }
      });
    },
    async closeModal() {
      this.isClosing = true;
      const modal = document.querySelector(".modal-attachfile-modal_content");
      const modalBackdrop = document.querySelector(".modal-backdrop");
      if (modal) {
        modalBackdrop.classList.remove("show");
        modal.classList.remove("slide-up");
        modal.classList.add("slide-down");
        modalBackdrop.classList.add("hide");
      }

      // รอ animation เสร็จแล้วค่อยปิด
      await new Promise((resolve) => setTimeout(resolve, 310));
      modal.classList.add("hidden");
      this.constantValue.modalShow = false;
      this.constantValue.isClosing = false;

      await new Promise((resolve) => setTimeout(resolve, 10));
      this.constantValue.isClosing = true;
    },
    closeDialogChooseFile(bvEvt) {
      // กันไม่ให้ปิดแบบ default ทันที
      if (this.isClosing) return;
      bvEvt.preventDefault(); // บังคับให้ใช้ closeModal แทน
      this.closeModal();
    },
    async onFileChange(e) {
      this.constantValue.modalShow = false;
      const files = e?.target?.files || e?.dataTransfer?.files;
      let isErrorSize = false;
      let isErrorTypeFile = false;
      let isErrorEmptyFile = false;
      let isErrorFileNameDuplicate = false;
      let filenameDup = [];
      // let filesDump = this.attachFile;
      if (files?.length) {
        const promises = Array.from(files).map(async (draftFile) => {
          if (draftFile.size == 0) {
            isErrorEmptyFile = true;
          } else {
            if (this.checkOverSize(draftFile.size)) {
              isErrorSize = true;
            } else {
              let file = await convertFileCloudToLocal(draftFile);
              const istype = await this.checkFileType(file.type);
              if (istype) {
                if (
                  this.attachFile.filter(
                    (i) => i.filename == file.name && i.filesize == file.size
                  ).length == 0
                ) {
                  if (file.name === "image.jpg") {
                    file = this.renameFile(file, this.create_UUID() + ".png");
                  }
                  //Append to realFiles
                  let tmpFile = {};
                  tmpFile.id = this.create_UUID();
                  tmpFile.type = this.documentTypeObj.doc_code;
                  tmpFile.name = this.documentTypeObj.doc_name;
                  tmpFile.file = file;
                  tmpFile.status = false;
                  tmpFile.filename = file.name;
                  tmpFile.filesize = file.size;
                  if (undefined !== this.uploadType && this.uploadType !== "") {
                    tmpFile.uploadType = this.uploadType;
                  }
                  if ("image/heic" === file.type) {
                    return this.convertHeicToJpg(
                      file,
                      this.documentTypeObj.doc_code,
                      this.documentTypeObj.doc_name
                    );
                  } else if ("application/pdf" !== file.type) {
                    return tmpFile;
                  } else {
                    return this.validatePdf(tmpFile);
                  }
                } else {
                  filenameDup.push(file);

                  this.size = this.size - file.size;
                  isErrorFileNameDuplicate = true;
                }
              } else {
                isErrorTypeFile = true;
              }
            }
          }
        });
        try {
          document.getElementById(
            "fileUpload_" + this.documentTypeObj.doc_code
          ).value = null;
          document.getElementById(
            "fileCamera_" + this.documentTypeObj.doc_code
          ).value = null;
          document.getElementById(
            "fileBrowseImage_" + this.documentTypeObj.doc_code
          ).value = null;
          document.getElementById(
            "fileBrowseFile_" + this.documentTypeObj.doc_code
          ).value = null;
          document.getElementById(
            "fileBrowseIOS_" + this.documentTypeObj.doc_code
          ).value = null;
        } catch (error) {
          console.error(error);
        }
        const results = await Promise.allSettled(promises);
        const validFiles = results
          .filter((r) => r.status === "fulfilled" && r.value !== null)
          .map((r) => r.value)
          .filter((r) => r);
        // console.log("validFiles", validFiles);
        const validFilesNotPassword = validFiles.filter(
          (r) => r?.fileHavePassword !== true
        );
        const validFilesIsPassword = validFiles.filter(
          (r) => r?.fileHavePassword === true
        );
        // console.log("validFiles", validFiles);
        if (
          validFilesNotPassword.length > 0 &&
          validFilesNotPassword[0] !== undefined
        ) {
          this.attachFile = [...this.attachFile, ...validFilesNotPassword];
          this.saveLocalFile();
        }
        // console.log("isErrorFileNameDuplicate", isErrorFileNameDuplicate);
        //Handle error message
        let alert = null;

        if (validFilesIsPassword.length > 0) {
          // this.saveLocalFile();
          for (const r of validFilesIsPassword) {
            await this.showAlertErrorPassword(r.filename, r);
          }
        }
        // console.log("isErrorSize", isErrorSize);
        if (isErrorTypeFile) alert = this.constantValue.alert.typefile;
        else if (isErrorEmptyFile) alert = this.constantValue.alert.fileEmpty;
        else if (isErrorSize) alert = this.constantValue.alert.size;
        else if (isErrorFileNameDuplicate) {
          await this.alertFilenameDuplicate(filenameDup);
        }
        if (alert) {
          this.showAlertError(alert.title, alert.detail, alert.close);
        }
        if (alert == null) {
          this.saveLocalFile();
        }
      }
    },
    checkOverSize(fileSize) {
      const maxSize = this.documentTypeObj.max_size * (1024 * 1024);
      return fileSize > maxSize ? true : false;
    },
    sendEventError() {
      this.documentTypeObj.state = "error";
      this.callback("save-state-upload", () => this.documentTypeObj);
    },
    getListFileByType() {
      return this.attachFile;
    },
    checkFileType(type) {
      switch (type) {
        case "application/pdf":
          return true;
        case "image/jpeg":
          return true;
        case "image/png":
          return true;
        case "image/heic":
          return true;
        default:
          return false;
      }
    },
    renameFile(originalFile, newName) {
      return new File([originalFile], newName, {
        type: "image/png",
        lastModified: originalFile.lastModified,
      });
    },
    saveLocalFile() {
      this.documentTypeObj.filesReal = this.attachFile;
      this.documentTypeObj.filesRealSize = this.getAllSize();
      if (this.attachFile.length > 0) {
        this.documentTypeObj.state = "attachfile";
      } else {
        this.documentTypeObj.state = "wait";
      }
      this.callback(this.documentTypeObj);
      // this.$store.dispatch("setUserData", this.userData);
    },
    remove(key) {
      let size = this.size;
      const item = this.attachFile.find((v) => v.id == key);
      if (item != undefined && !item.status && item.file != undefined) {
        size = size - item.file.size;
        this.size = size >= 0 ? size : 0;
        this.attachFile = this.attachFile.filter((v) => v.id != key);
      }
      this.saveLocalFile();
    },
    viewDoc(key) {
      const data = this.attachFile.find((v) => v.id == key);
      const file = data.file;
      if (file != undefined) {
        const url = URL.createObjectURL(file);
        window.open(
          url,
          "popUpWindow",
          "height=400,width=600,left=10,top=10,,scrollbars=yes,menubar=no"
        );
      }
    },
    getPreview(key) {
      const data = this.getListFileByType().find((v) => v.id == key);
      const file = data.file;
      if (file) {
        if ("application/pdf" === file.type) {
          return require("@/assets/images/upload_type_document.png");
        } else {
          return require("@/assets/images/upload_type_img.png");
        }
      }
    },
    getFileType(key) {
      const data = this.getListFileByType().find((v) => v.id == key);
      const file = data.file;
      if (file) {
        if ("application/pdf" === file.type) {
          return "pdf";
        }

        return "img";
      }
    },
    getFileSize(fSize) {
      var fSExt = new Array("Bytes", "KB", "MB", "GB");
      var i = 0;
      while (fSize > 900) {
        fSize /= 1000;
        i++;
      }
      return Number(fSize).toFixed(1) + " " + fSExt[i];
    },
    create_UUID() {
      var dt = new Date().getTime();
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    getAllSize() {
      let bytes = 0;
      // console.log("attachFile from getAllSize", this.attachFile);
      this.attachFile.forEach((i) => {
        bytes = bytes + i.filesize;
      });
      return bytes;
    },
    async validatePdf(tmpFile) {
      const showAlertError = this.showAlertError;
      var loadingTask = pdf.createLoadingTask(
        URL.createObjectURL(tmpFile.file)
      );
      try {
        await loadingTask.promise;
        return tmpFile;
      } catch (error) {
        if (error === undefined || error?.name === "PasswordException") {
          console.error("error pdf", error);
          tmpFile.fileHavePassword = true;
          tmpFile.fileCheckassword = null;
          return tmpFile;
        } else {
          showAlertError(
            "ไม่สามารถเปิดไฟล์ได้",
            "กรุณาตรวจสอบไฟล์อีกครั้ง",
            "ตกลง"
          );
          return null;
        }
      } finally {
        loadingTask.destroy();
      }
    },
    async validateFileHavePassword(tmpFile, value) {
      // console.log("Check password pdf");
      let loadingTask;

      try {
        loadingTask = pdf.createLoadingTask(URL.createObjectURL(tmpFile.file));

        let passwordAttempts = 0;
        loadingTask.onPassword = function (updatePassword) {
          passwordAttempts++;
          if (passwordAttempts > 1) {
            throw new Error("Incorrect password");
          } else {
            updatePassword(value);
          }
        };

        await loadingTask.promise;

        tmpFile.fileHavePassword = false;
        tmpFile.fileCheckassword = true;
        tmpFile.password = value;

        return tmpFile;
      } catch (error) {
        console.error("Password validation error");
        return null;
      } finally {
        if (loadingTask) {
          loadingTask.destroy();
        }
      }
    },
    validateTotalPdf() {
      return (
        this.attachFile.filter((item) => item.fileHavePassword).length == 0
      );
    },
    alertFilenameDuplicate(filenameDup) {
      let message = this.constantValue.alert.filenameDuplicate.detail;
      let i = 0;
      filenameDup.forEach((p) => {
        if (i > 0) message += ",";
        message += '<br />"' + p.name + '"';
        i++;
      });
      Warning(
        {
          title: this.constantValue.alert.filenameDuplicate.title,
          message: message,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "เลือกใหม่",
          state: "warning",
          confirmCallBack: () => {
            this.updateFileDuplicate(filenameDup);
          },
        },
        this.$swal
      );
    },
    async updateFileDuplicate(files) {
      // console.log("this.attachFile 1", this.attachFile);
      let dumpFile = [...this.attachFile.map((r) => r)];
      if (files?.length) {
        const promises = Array.from(files).map(async (file) => {
          const istype = await this.checkFileType(file.type);
          if (istype) {
            //Append to realFiles
            let indexFile = -1;
            let tmpFile = {};
            for (var i = 0; i < dumpFile.length; i++) {
              if (
                dumpFile[i].filename == file.name &&
                dumpFile[i].filesize == file.size
              ) {
                tmpFile = dumpFile[i];
                indexFile = i;
                break;
              }
            }

            if (indexFile > -1) {
              // console.log("indexFile", indexFile);
              dumpFile.splice(indexFile, 1);
              tmpFile.type = this.documentTypeObj.doc_code;
              tmpFile.name = this.documentTypeObj.doc_name;
              tmpFile.file = file;
              tmpFile.status = false;
              tmpFile.filename = file.name;
              tmpFile.filesize = file.size;
              if ("application/pdf" !== file.type) {
                return tmpFile;
              } else {
                return this.validatePdf(tmpFile);
              }
            }
          }
        });
        await Promise.allSettled(promises);
        const results = await Promise.allSettled(promises);

        const validFiles = results
          .filter((r) => r.status === "fulfilled" && r.value !== null)
          .map((r) => r.value)
          .filter((r) => r);
        const validFilesNotPassword = validFiles.filter(
          (r) => r?.fileHavePassword !== true
        );
        const validFilesIsPassword = validFiles.filter(
          (r) => r?.fileHavePassword === true
        );
        // console.log("dumpFile", dumpFile);
        // console.log("validFilesNotPassword", validFilesNotPassword);
        // console.log("validFilesIsPassword", validFilesIsPassword);
        this.attachFile = [...dumpFile, ...validFilesNotPassword];
        // console.log("this.attachFile 2", this.attachFile);
        if (validFilesIsPassword.length > 0) {
          this.saveLocalFile();
          for (const r of validFilesIsPassword) {
            await this.showAlertErrorPassword(r.filename, r);
          }
        } else {
          this.saveLocalFile();
        }
      }
    },
    showAlertError(title, message, close) {
      Warning(
        {
          title: title,
          message: message,
          confirmButtonText: close,
          cancelButtonText: "",
          state: "warning",
          confirmCallBack: () => { },
        },
        this.$swal
      );
    },
    showAlertErrorPassword(filename, tmpFile) {
      return WarningPassword(
        {
          message: filename,
          confirmCallBack: (tmpFile) => {
            // console.log("tmpFile", tmpFile);
            let filesDump = this.attachFile;
            filesDump.push(tmpFile);
            this.attachFile = filesDump;
            this.saveLocalFile();
          },
        },
        this.$swal,
        this,
        tmpFile
      );
    },
    checkDocIsSuccess() {
      return (
        this.documentTypeObj.state != undefined &&
        this.documentTypeObj.state == "success"
      );
    },
    calcHeight() {
      var h = window.innerHeight;
      return h < 680;
    },
    setIsConvertingHeic(value) {
      this.constantValue.isConvertingHeic = value;
    },
    async convertHeicToJpg(fileHeic, docCode, docName) {
      const showAlertError = this.showAlertError;
      const create_UUID = this.create_UUID;
      const setConvertingHeic = this.setIsConvertingHeic;

      setConvertingHeic(true);

      try {
        const buffer = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsArrayBuffer(fileHeic);
        });

        const blob = new Blob([buffer], { type: "image/heic" });
        const conversionResult = await heic2any({ blob, toType: "image/jpeg" });

        const fileName =
          fileHeic.name.substring(0, fileHeic.name.lastIndexOf(".")) ||
          fileHeic.name;

        const jpegFile = new File([conversionResult], fileName + ".jpeg", {
          type: "image/jpeg",
        });

        const tmpFile = {
          id: create_UUID(),
          type: docCode,
          name: docName,
          file: jpegFile,
          status: false,
          filename: jpegFile.name,
          filesize: jpegFile.size,
        };

        return tmpFile;
      } catch (e) {
        showAlertError(
          this.constantValue.alert.typefile.title,
          this.constantValue.alert.typefile.detail,
          this.constantValue.alert.typefile.close
        );
        return null;
      } finally {
        setConvertingHeic(false);
      }
    },
    showExample() {
      const event = {
        action: 'Click',
        category: 'DGL_PT_FollowUpDocUpload',
        label: 'DGL_PT_FollowUpDocUpload_Example',
        value: '',
      };
      if("1115" == this.userData.marketCode && "7002" == this.userData.productType){
        const product = {
          key: "product_type",
          value: "DL_SMARTMONEY"
        }
        const dimension = [product];
        try {
          this.$callback.gaTagging(event, dimension);
        } catch (err) {
          console.error("GA Tagging error", err);
        }
      }
      exampleDoc(this.documentTypeObj.example_doc, this.$swal);
    },
    hideModalUpload() {
      this.$root.$emit("bv::hide::modal", "modal-upload", "#btnToggle");
    },
  },
};
</script>

<style>
.btn-swal-width {
  width: 45%;
  margin-left: 0.5rem;
}

a {
  color: black;
  text-decoration: none;
}

a:hover,
a:focus {
  color: black;
  text-decoration: none;
}

.deviate-text {
  color: #ff6961;
  font-size: 0.75rem;
}

.document-info>.title {
  color: #00a3e4;
}

.document-info>.header {
  color: #000000;
}

.document-info>.body {
  color: #8e94a4;
}

.btn-upload-true {
  background-color: #3f62f1 !important;
  color: #3c68ce !important;
  border-color: #e3e4e8 !important;
}

.btn-ktb-deviate {
  background-color: white !important;
  color: #df0747 !important;
  border-color: #f93972 !important;
}

.btn-goback {
  background-color: white !important;
  color: #00a3e4 !important;
  border-color: #00a3e4 !important;
}

.text-upload-true {
  color: #aaafbb !important;
}

.alert-warning {
  color: #b98f13;
  background-color: #fdf8e7;
  border-color: #ffeeba;
  border-left-color: #f5d470;
  border-left-width: 4px;
}

.status-color-2 {
  color: #daa60b !important;
}

.status-color-3 {
  color: #479e6a !important;
}

.status-color-6 {
  color: #aaafbb !important;
}

.status-color-5,
.status-color-1,
.status-color-4 {
  color: #df0747 !important;
}

.progress-upload-custom {
  height: 0.4rem !important;
  width: 100%;
  background-color: #f8f8f8 !important;
}

.progress-bar {
  background-color: #4457e3;
}

.progress-bar>.bg-danger {
  background-color: rgb(219, 0, 0);
}

.use-memory {
  text-align: center;
}

.size-memory {
  margin: 0;
  font-family: KrungthaiFast-Bold, Arial, sans-serif !important;
  color: rgb(0, 166, 230) !important;
  font-size: 14px !important;
}

.badge-primary {
  border: 1.5px solid #33c5ff;
  box-sizing: border-box;
  position: absolute;
  margin: -10px 0px;
  margin-top: 0rem;
  color: #33c5ff;
  background-color: transparent;
  width: 20px;
  height: 20px;
}

.text-document {
  color: #919595;
}

.upload-button-revamp {
  background-color: #ffffff;
  color: var(--color-primary) !important;
  width: 100%;
  height: 56px;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='25' ry='25' stroke='%23015AF5FF' stroke-width='2' stroke-dasharray='3%2c 6' stroke-dashoffset='46' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 25px;
}

.body-style {
  padding-left: 0px;
  padding-right: 0px;
}

.preview-img {
  width: 32px;
  height: 32px;
  /* border: 1px solid rgb(188, 204, 214); */
  /* border-radius: 8px; */
}

.preview-pdf {
  width: 32px;
  height: 32px;
  /* border-radius: 5px; */
  /* background: rgba(242, 242, 242, 1); */
}

.view-example {
  text-decoration: underline;
  color: #087ffd !important;
}

.text-danger {
  text-align: center;
  color: rgb(219, 0, 0);
  font-family: KrungthaiFast-Regular, Arial, sans-serif !important;
  font-size: 14px !important;
}

.btn-secondary.disabled,
.btn-secondary:disabled {
  background-color: #8e94a4 !important;
  border-color: #8e94a4 !important;
  background-image: linear-gradient(-90deg, #00b3f0, #006a9e) !important;
}

.danger-true {
  color: rgb(219, 0, 0);
}

.content-nowrap {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-left: unset;
}

.card-doc-err {
  background-color: #feeee3;
  border-radius: 16px !important;
  border: 1px solid #feeee3;
  margin-bottom: 10px;
  box-shadow: 0px 2px 4px 0px rgb(188, 204, 214, 0.4) !important;
}

.card-doc-err-detail {
  color: #e17f00;
}

.format-pre pre {
  background: #49483e;
  color: #f7f7f7;
  padding: 10px;
  font-size: 14px;
}

.modal-dialog-centered {
  display: grid;
  align-items: end;
  min-height: calc(100% - 1rem);
}

.btn-noborder {
  background-color: #ffffff;
  border-color: #ffffff;
  color: black;
}

.vl {
  border-left: 1px solid gray;
  height: 100px;
}

.btn-back-step {
  width: inherit;
  color: #00a3e4;
  background-color: #ffffff;
  border-color: #ffffff;
  border-radius: unset;
}

.text-header-center {
  text-align: center;
  font-size: 20px;
}

.icon-back {
  color: #00a7ec;
}

.badge-ktb-info {
  box-sizing: border-box;
  position: absolute;
  margin: -10px -10px;
  margin-top: 0rem;
  color: rgb(0, 166, 230) !important;
  background-color: transparent;
  width: 24px;
  height: 24px;
}

.badge-primary {
  border: 2px solid rgb(0, 166, 230);
  box-sizing: border-box;
  position: absolute;
  margin: -10px 0px;
  margin-top: 2px;
  color: rgb(0, 166, 230) !important;
  background-color: transparent;
  width: 24px;
  height: 24px;
}

.modal-attachfile-modal_content {
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 32px 32px 0 0 !important;
  outline: 0;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateY(0);
}

.modal-attachfile-modal_content.slide-up {
  animation: slideUp 0.3s ease-out forwards !important;
}

.modal-attachfile-modal_content.slide-down {
  animation: slideDown 0.3s ease-in forwards !important;
}

.modal-attachfile-modal_content.slide-down.hidden {
  display: hidden;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform: translateY(100%);
    opacity: 0;
  }
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #111928b2 !important;
  animation: opacityShow 0.3s ease-in forwards !important;
}

.modal-backdrop.hide {
  animation: opacityHide 0.3s ease-in forwards !important;
}

@keyframes opacityShow {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes opacityHide {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.uploads-content-card-md {
  min-height: 43%;
}

.uploads-content-card-sm {
  min-height: 23%;
}

.form-control.is-invalid,
.was-validated .form-control:invalid {
  background-image: unset !important;
}

.html-container-file-duplication {
  line-height: 24px !important;
  letter-spacing: -0.5px !important;
}

.swal2-title {
  position: relative;
  max-width: 100%;
  margin: 0;
  /* padding: 0.8em 1em 0; */
  color: inherit;
  font-size: 1.875em;
  font-weight: 600;
  text-align: center;
  text-transform: none;
  word-wrap: break-word;
}

.swal-title-duplication-file {
  font-family: Kanit-Bold, Arial, sans-serif !important;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #212121 !important;
}

.password-icon-false {
  float: right;
  margin-left: -30px;
  margin-top: -45px;
  margin-right: 5px;
  position: relative;
  z-index: 2;
}

.password-icon-true {
  float: right;
  margin-left: -30px;
  margin-top: -35px;
  margin-right: 5px;
  position: relative;
  z-index: 2;
}

.form-control.is-invalid,
.was-validated .form-control:invalid {
  background-image: unset !important;
  font-family: Kanit-Regular;
}

input:focus~.floating-label-false {
  top: 8px;
  bottom: 10px;
  left: 20px;
  font-size: 14px !important;
  font-family: Kanit-Regular;
  opacity: 1;
  color: #4457e3;
}

.floating-label-false {
  position: absolute;
  pointer-events: none;
  left: 20px;
  top: 18px;
  font-size: 20px !important;
  transition: 0.2s ease all;
  font-family: Kanit-Regular;
  color: #838383;
}

.floating-label-true {
  position: absolute;
  pointer-events: none;
  top: 8px;
  bottom: 10px;
  left: 20px;
  font-size: 14px !important;
  opacity: 1;
  transition: 0.2s ease all;
  font-family: Kanit-Regular;

  color: #4457e3;
}

.form-control {
  height: calc(1.5em + 0.75rem + 30px);
  border-radius: 8px !important;
}

.floating-text-true {
  color: #00a408;
}

.floating-text-false {
  color: #dc3545;
}
</style>
<style scoped>
.swal2-html-container {
  z-index: 1 !important;
  justify-content: center !important;
  margin: 1em 1.6em 0.3em !important;
  padding: 0 !important;
  overflow: auto !important;
  color: #212121 !important;
  font-size: 1.125em !important;
  font-weight: normal !important;
  line-height: normal !important;
  text-align: center !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
}

.btn-submit-landing-page {
  font-size: 18px !important;
  height: 46px !important;
  border-radius: 8px !important;
  font-family: Kanit-Bold, Arial, sans-serif !important;
  color: white !important;
  background: linear-gradient(274.84deg, #4457e3 0%, #5367ff 100%) !important;
}

.btn-submit-landing-page.disabled,
.btn-submit-landing-page:disabled {
  color: #ffffff !important;
  background-color: #e0e0e0 !important;
  border-color: #e0e0e0 !important;
  background-image: none !important;
}

.hr-style {
  border: 1px solid #f2f2f2 !important;
}

.noborder {
  border: 0px !important;
}
</style>
